import clsx from "clsx";
import { IconProps } from "@/types/icons";
import { createColorClasses } from "@/theme/colors";

export const MedicHistory = ({
  width = 24,
  height = 24,
  className,
  color,
  decorative = false,
  ariaLabel = "Medical history",
}: IconProps) => {
  const classes = createColorClasses({ color });

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="currentColor"
      viewBox="0 0 24 24"
      className={clsx(className, classes)}
      aria-hidden={decorative}
      aria-label={!decorative ? ariaLabel : undefined}
    >
      <path
        fill={clsx(color ? color : "#06C")}
        fillRule="evenodd"
        d="M4 16V2h16v14h-3.69l-1 2H8.69l-1-2zm11.69-1H19V3H5v12h3.31l1 2h5.38zM19 17h1v5H4v-5h1v4h14zM7 6h10V5H7zm10 3H7V8h10zM7 12h10v-1H7z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
};


